export default __webpack_public_path__ + "static/media/pendente-icon.8331e5f1.svg";